import React from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'

import { usePersistedState } from 'hooks'
import { entities } from 'reduxStore'

import { Application } from 'components/JobBoardDetails'
import { ResumeViewRedesigned } from 'components/ResumeView'
import { TopBarRedesigned, AdditionalActionsIconType } from "components/TopBarRedesigned";

declare let window: any
declare let cordova: any

const PageWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	background-color: #fff;
	overflow: auto;
	position: relative;
	min-height: 100vh;
`;

export default function DentistResumeViewPage() {
	const history = useHistory()

	const application = usePersistedState<Application>({
		entityName: entities.dentistCandidateApplication,
	})[0]

	const hireResumeUrl = application?.hireResumeUrl;

	const onResumeDownload = () => {
		if (!hireResumeUrl) {
			return
		}

		return window.Cordova ?
			cordova.InAppBrowser.open(
				hireResumeUrl,
				'_system',
				'location=yes'
			) : window.open(hireResumeUrl)
	}

	return (
		<PageWrapper>
			<TopBarRedesigned
				title="Candidate"
				onBack={() => {
					history.goBack()
				}}
				onAdditionalActionsButtonClick={onResumeDownload}
				additionalActionsIconType={AdditionalActionsIconType.download}
			/>
			<ResumeViewRedesigned
				name={application.name}
				file={application?.hireResumeUrl}
				onDownload={onResumeDownload}
			/>
		</PageWrapper>
	)
}
